
import { Link } from "react-router-dom";

export function ProjectHeader() {
  return (
    <header className="border-b border-border/40 bg-stdly-blue backdrop-blur supports-[backdrop-filter]:bg-stdly-blue/90">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="/lovable-uploads/1268e013-62c0-4efc-98ef-21ea816431fb.png" 
            alt="Standardly Logo" 
            className="h-8 w-auto" 
          />
        </Link>
      </div>
    </header>
  );
}
